module.exports = __webpack_public_path__ + "img/Mover_Back_Side_Left.b3387301.svg";